import React from "react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { CheckList } from "../CheckList";
import { finalIncludes } from "../../data/content";
import { MOCKUP_URL, PRICE, REFERENCE_PRICE } from "../../data/site";
export function FinalCtaSection() {
  return <section className="bg-navy px-4 py-16 sm:py-24" data-id="element-166" data-mp="2di1w4zvo9rvk">
      <div className="mx-auto max-w-3xl text-center" data-id="element-167" data-mp="2rimjm9cj8bve">
        <p className="text-sm font-extrabold uppercase tracking-[0.14em] text-gold" data-id="element-168" data-mp="2rh1k05bd22qo">
          Ready to build a more structured understanding?
        </p>
        <h2 className="mt-3 text-[1.9rem] font-extrabold leading-[1.12] tracking-tight text-white sm:text-5xl" data-id="element-169" data-mp="317w8lgc2xefa">
          Stop searching through disconnected resources. Start studying with a clearer structure.
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-brand-sky" data-id="element-170" data-mp="3aa5grzjvkvpi">
          With six specialized volumes and five complementary bonuses, you’ll have an organized educational collection for reviewing
          essential hemodynamic concepts, understanding cardiovascular physiology, and practicing reasoning through simulated clinical
          cases.
        </p>

        <img src={MOCKUP_URL} alt="Hemodynamic Monitoring Blueprint collection" className="mx-auto mt-8 w-full max-w-md" data-id="element-171" data-mp="2b0zooy1ux3t3" />

        <div className="mt-8 rounded-3xl bg-navy-800 p-5 text-left ring-1 ring-white/10 sm:p-8" data-id="element-172" data-mp="2g158xt5sro15">
          <p className="mb-5 text-center text-base font-extrabold uppercase tracking-wide text-white" data-id="element-173" data-mp="2kynlrumxqnef">Your complete collection includes</p>
          <CheckList items={finalIncludes} tone="dark" columns data-id="element-174" data-mp="2oynz1byassjw" />
        </div>

        <div className="mt-10" data-id="element-175" data-mp="2tsioyx4hy3rf">
          <p className="text-base font-bold uppercase tracking-wide text-brand-sky" data-id="element-176" data-mp="2yqk9lmhkmb50">Get the complete Blueprint™ for</p>
          <div className="mt-2 flex items-end justify-center gap-3" data-id="element-177" data-mp="33qptgghlmtcj">
            <span className="pb-3 text-2xl font-bold text-brand-sky line-through decoration-alert decoration-[3px]" data-id="element-178" data-mp="38p12wq3zf1u8">{REFERENCE_PRICE}</span>
            <span className="text-[5.5rem] font-extrabold leading-none tracking-tight text-gold sm:text-9xl" data-id="element-179" data-mp="2j1xcv23lwahp">{PRICE}</span>
            <span className="pb-3 text-xl font-bold text-white" data-id="element-180" data-mp="2e3cbgzcmbkro">USD</span>
          </div>
          <p className="mt-2 text-sm font-bold uppercase tracking-wider text-brand-sky" data-id="element-181" data-mp="2srguy5jhw0bi">One-time payment · Digital educational product</p>
        </div>

        <div className="mt-8" data-id="element-182" data-mp="31rdghyal8j2c">
          <CtaButton label="Yes! I want the Hemodynamic Monitoring Blueprint™" data-id="element-183" data-mp="31qc2pm26tigx" />
        </div>
        <Countdown tone="dark" data-id="element-184" data-mp="2wt22rch69oeu" />
        <ScarcityBar tone="dark" data-id="element-185" data-mp="2ws0rp805p1x4" />
        <p className="mt-5 text-sm font-medium text-brand-sky" data-id="element-186" data-mp="3bpjbrx1w2qy8">
          Digital delivery · No monthly subscription · Seven-day satisfaction guarantee · Automatic currency conversion
        </p>
      </div>
    </section>;
}